<template>
  <div id="app" class="min-h-screen flex flex-col">
    <router-view />
  </div>
</template>

<script setup lang="ts">
// Smooth scroll se maneja con CSS: scroll-behavior: smooth
</script>

<style>
/* Global styles se manejan en main.css */
</style>
